import { State } from '../reducers/rootReducer'

const activeRenderImgIdxSelector = (state: State): number => state.activeRenderImageIdx

export default activeRenderImgIdxSelector
